import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';
import { SpecialOfferRotator } from './components/special-offer-rotator';

/** Renders the special offer rotator. Returns null when not a special offer. */
export function CardSpecialOffer(): JSX.Element | null {
  const { isSpecialOffer, specialNames, hideSalesLanguage } = useCardContext();

  if (!isSpecialOffer) {
    return null;
  }

  return (
    <Wrapper>
      <SpecialOfferRotator specialNames={specialNames} hideSalesLanguage={hideSalesLanguage} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: ${13 / 12};
  text-transform: ${({ theme }) => theme.customized.textTransforms.tags};
`;
